export const CpData = [
  {
    platform: "Codeforces",
    handle: "Deepak_23",
    link: "https://codeforces.com/profile/Deepak_23",
    icon: require("../../assets/codeforces.png"),
  },
  {
    platform: "CodeChef",
    handle: "aomine_23",
    link: "https://www.codechef.com/users/aomine23",
    icon: require("../../assets/codechef.png"),
  },
  {
    platform: "HackerEarth",
    handle: "aomine23",
    link: "https://www.hackerearth.com/@aomine23",
    icon: require("../../assets/hackerearth.png"),
  },
  {
    platform: "HackerRank",
    handle: "_Aomine_",
    link: "https://www.hackerrank.com/_Aomine_",
    icon: require("../../assets/hackerrank.png"),
  },
  {
    platform: "LeetCode",
    handle: "_Aomine_",
    link: "https://leetcode.com/_Aomine_/",
    icon: require("../../assets/leetcode.png"),
  },
  {
    platform: "ICPC",
    handle: "Deepak Barnwal",
    link: "https://icpc.global/ICPCID/RFUJWXMQD9BL",
    icon: require("../../assets/icpc.png"),
  },
];
